import {
  EmailSubscriptionsServiceClientImpl,
  SubscribeToDropResponse,
} from '../../../grpc_client/grips/protos/email_subscriptions/v1/email_subscriptions_service';
import {
  useGripsClientContext,
  useGrpcClientChannel,
} from '../../../ui/sharedContexts/GrpcClientContext';
import {getGripsDevice} from '../../../utils/grpc/grpc-device';
import {
  AsyncOperationReturnType,
  useAsyncOperation,
} from '../../../utils/hooks/useAsyncOperation';
import {useDropSourceFromDrop} from '../../../utils/hooks/useDropSourceFromDrop';
import {useUpdateIndividualStoredSubscriptions} from './useUpdateIndividualStoredSubscriptions';

export const useSubscribeToDrop = (
  preferredEmail: string,
  dropId: number | undefined,
): AsyncOperationReturnType<
  SubscribeToDropResponse,
  Error,
  [string, number]
> => {
  const {childShopId, shopId, device} = useGripsClientContext();
  const channel = useGrpcClientChannel();
  const dropSource = useDropSourceFromDrop('individual');

  const [subscribeToDrop, subscribeToDropState] = useAsyncOperation(
    async (email: string, dropId: number) => {
      const client = new EmailSubscriptionsServiceClientImpl(channel);

      return await client.subscribeToDrop({
        config: {
          childShopId,
          shopId,
          device: getGripsDevice(device),
        },
        email,
        dropId,
        source: dropSource,
      });
    },
    [channel, childShopId, device],
  );

  useUpdateIndividualStoredSubscriptions({
    state: subscribeToDropState,
    preferredEmail,
    dropId: dropId || 0,
  });

  return [subscribeToDrop, subscribeToDropState];
};
